document.addEventListener('DOMContentLoaded', function () {
  const form = document.querySelector('.automatic-response');
  console.log('dom loaded, form:', form)

  form.addEventListener('submit', function (event) {
    console.log('Submit event listenr:', event)
    event.preventDefault(); // Prevent the default form submission

    // Get form data
    var formData = new FormData(form);
    console.log('formData:', formData)

    // Make an AJAX request
    var xhr = new XMLHttpRequest();
    console.log('xhr:', xhr)
    
    xhr.open('POST', 'https://artich-io.app.n8n.cloud/webhook/form-submit', true);
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');

    xhr.onload = function () {
      console.log('Form submission status:', xhr.status);
      console.log('Form submission response:', xhr.responseText);

      if (xhr.status >= 200 && xhr.status < 300) {
        // Success handling, if needed
        console.log('Form submission successful');
      } else {
        // Error handling
        console.error('Form submission failed');
      }
    };

    xhr.onerror = function () {
      // Network error handling
      console.error('Network error during form submission');
    };

    xhr.send(new URLSearchParams(formData)); // Send form data as URL-encoded parameters
  });
    console.log('event:', event)
    console.log('event:', event)
    console.log('event:', event)
    console.log('event:', event)
    console.log('event:', event)
    console.log('event:', event)
    console.log('event:', event)
    console.log('event:', event)
    console.log('event:', event)
    console.log('event:', event)
    console.log('event:', event)
    console.log('event:', event)
    console.log('event:', event)
    console.log('event:', event)
    console.log('event:', event)
    console.log('event:', event)
});